<template>  

  <v-content style="background:#525659" class="contentDiv">
          <v-container fluid>
            <router-view></router-view>
          </v-container>            
  </v-content>

  </v-app>
</template>

<script>
  import HeaderBar from '../components/header.vue'
    import SideBar from '../components/sidebar.vue'

    export default {
        components: {HeaderBar, SideBar},
    data: () => ({
      drawer: null
    }),
    props: {
      source: String
    },
    computed: {
        year(){
         var d = new Date();
         return d.getFullYear();          
        },

        title() {
          let proInfo = this.$store.getters.GET_PROJECT_INFO;
          let moduleTitle = this.$store.getters.GET_MODULE_NAME;
          return (
            "MIS & Accounting Software for " +
            proInfo.project_name_short +
            " (" +
            moduleTitle +
            " Module)"
            );
      },
  }
  };
</script>

<style scope>
.green.darken-2 {
    background-color: #388E43 !important;
    border-color: #388E43 !important;
    opacity: 0.9;
}  
.footer{
    position: fixed;
    bottom: 30px;
}
</style>


// WEBPACK FOOTER //
// src/layouts/reportLayout.vue